/**
 * 参数校验错误类
 * 用于统一参数校验错误的格式
 */
export class InvalidParamsError extends Error {
  public code: string
  public field?: string

  constructor(message: string, field?: string) {
    super(message)
    this.name = 'InvalidParamsError'
    this.code = 'INVALID_PARAMS'
    this.field = field
  }

  toJSON() {
    return {
      code: this.code,
      message: this.message,
      field: this.field,
    }
  }
}
